"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function omni(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M7.54875 5.166C6.5931 5.78976 5.77821 6.60618 5.15625 7.563V5.166H7.54875ZM18.8018 7.4985C18.1851 6.5692 17.3853 5.77551 16.4513 5.166H18.8018V7.4985ZM16.4858 18.8115C17.4051 18.2049 18.1927 17.4192 18.8018 16.5015V18.8115H16.4858ZM5.15625 16.437C5.77062 17.3822 6.57334 18.1906 7.51425 18.8115H5.15625V16.437ZM19.5 12C19.5 16.1355 16.1355 19.5 12 19.5C7.8645 19.5 4.5 16.1355 4.5 12C4.5 7.8645 7.8645 4.5 12 4.5C16.1355 4.5 19.5 7.8645 19.5 12ZM12 17.469C15.015 17.469 17.469 15.0157 17.469 12C17.469 8.985 15.0157 6.531 12 6.531C8.985 6.531 6.531 8.98425 6.531 12C6.531 15.015 8.98425 17.469 12 17.469Z", fill: color }));
}
exports["default"] = omni;
//# sourceMappingURL=omni.js.map